export default "__VITE_ASSET__2ZfKOh95__ 720w";